module.exports = "<kendo-grid-boolean-filter-cell\n    [column]=\"column\"\n    [filter]=\"filter\"\n></kendo-grid-boolean-filter-cell>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/filters/row/boolean/boolean.component.html
// module id = ./libs/chassis-datatable/src/components/filters/row/boolean/boolean.component.html
// module chunks = main